export default "__VITE_ASSET__CxpaMm9f__"